// PartCPage9.jsx - Part C Page 9 for HPC Report (Pixel-perfect redesign - Overview with tables and performance checkboxes)
import React from 'react';

const PartCPage9 = ({ data }) => {
  const teacherFields = data?.teacher_fields || {};
  const studentFields = data?.student_fields || {};

  const renderSection = (title, bgColor, headerTextColor, stage1, stage2, stage3, performanceLevel, showTotal = true) => {
    const total = {
      awareness: (stage1?.awareness || 0) + (stage2?.awareness || 0) + (stage3?.awareness || 0),
      sensitivity: (stage1?.sensitivity || 0) + (stage2?.sensitivity || 0) + (stage3?.sensitivity || 0),
      creativity: (stage1?.creativity || 0) + (stage2?.sensitivity || 0) + (stage3?.creativity || 0)
    };

    return (
      <div style={{ marginBottom: '15px' }}>
        <div style={{
          backgroundColor: bgColor,
          color: headerTextColor,
          padding: '6px 10px',
          fontWeight: 'bold',
          fontSize: '11px',
          display: 'inline-block',
          marginBottom: '8px'
        }}>
          {title}
        </div>

        <div style={{ display: 'flex', gap: '15px', alignItems: 'flex-start' }}>
          {/* Table on the left */}
          <table style={{
            borderCollapse: 'collapse',
            fontSize: '10px',
            backgroundColor: title.includes('Teacher') ? '#FFE5D5' : title.includes('Learner') ? '#FFEDCC' : '#FFF9E6',
            flex: '0 0 auto'
          }}>
            <thead>
              <tr style={{ backgroundColor: title.includes('Teacher') ? '#FFB380' : title.includes('Learner') ? '#FFD966' : '#FFE082' }}>
                <th style={{ border: '1px solid #999', padding: '6px', minWidth: '100px' }}></th>
                <th style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Awareness</th>
                <th style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Sensitivity</th>
                <th style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Creativity</th>
              </tr>
            </thead>
            <tbody>
              {stage1 !== null && (
                <tr>
                  <td style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Stage 1</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage1?.awareness || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage1?.sensitivity || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage1?.creativity || 0}</td>
                </tr>
              )}
              {stage2 !== null && (
                <tr>
                  <td style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Stage 2</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage2?.awareness || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage2?.sensitivity || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage2?.creativity || 0}</td>
                </tr>
              )}
              {stage3 !== null && (
                <tr>
                  <td style={{ border: '1px solid #999', padding: '6px', fontWeight: 'bold' }}>Stage 3</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage3?.awareness || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage3?.sensitivity || 0}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{stage3?.creativity || 0}</td>
                </tr>
              )}
              {showTotal && (
                <tr style={{ fontWeight: 'bold', backgroundColor: title.includes('Teacher') ? '#FFB380' : title.includes('Learner') ? '#FFD966' : '#FFE082' }}>
                  <td style={{ border: '1px solid #999', padding: '6px' }}>Total</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{total.awareness}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{total.sensitivity}</td>
                  <td style={{ border: '1px solid #999', padding: '6px', textAlign: 'center' }}>{total.creativity}</td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Performance level checkboxes on the right */}
          <div style={{ flex: 1, fontSize: '9px' }}>
            {['Awareness', 'Sensitivity', 'Creativity'].map((category, idx) => (
              <div key={idx} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{
                  backgroundColor: '#3F51B5',
                  color: 'white',
                  padding: '4px 10px',
                  fontWeight: 'bold',
                  minWidth: '80px',
                  textAlign: 'center',
                  borderRadius: '2px'
                }}>
                  {category}
                </div>
                {['Beginner\n(0-5)', 'Proficient\n(6-10)', 'Advanced\n(11-16)'].map((level, levelIdx) => (
                  <div key={levelIdx} style={{
                    backgroundColor: '#FFD966',
                    border: '2px solid #333',
                    borderRadius: '50%',
                    width: '55px',
                    height: '55px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    padding: '3px',
                    fontSize: '8px',
                    textAlign: 'center',
                    lineHeight: '1.1',
                    fontWeight: 'bold'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-8px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      width: '14px',
                      height: '14px',
                      border: '2px solid #333',
                      backgroundColor: 'white',
                      borderRadius: '2px'
                    }}>
                      {performanceLevel && performanceLevel[category.toLowerCase()] === level.split('\n')[0] && '✓'}
                    </div>
                    {level.split('\n').map((line, i) => <div key={i}>{line}</div>)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="report-page" style={{
      width: '210mm',
      minHeight: '297mm',
      padding: '20mm',
      backgroundColor: 'white',
      boxSizing: 'border-box',
      fontFamily: 'Arial, sans-serif',
      position: 'relative'
    }}>
      {/* Top-right corner */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '0 80px 80px 0',
        borderColor: 'transparent #F4824C transparent transparent'
      }} />

      {/* Header */}
      <div style={{
        fontSize: '16px',
        fontWeight: 'bold',
        marginBottom: '5px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '10px'
      }}>
        Overview
      </div>
      <div style={{
        fontSize: '11px',
        marginBottom: '15px',
        textAlign: 'center',
        backgroundColor: '#F4824C',
        color: 'white',
        padding: '6px',
        fontWeight: 'bold'
      }}>
        Tabulate all the feedback for the research task on this page.
      </div>

      {/* Teacher Assessment */}
      {renderSection(
        'Teacher Assessment',
        '#F4824C',
        'white',
        teacherFields.stage_1_total,
        teacherFields.stage_2_total,
        teacherFields.stage_3_total,
        teacherFields.performance_level,
        true
      )}

      {/* Learner Reflection */}
      {renderSection(
        'Learner Reflection',
        '#FFD966',
        'black',
        studentFields.learner_stage_1_total,
        studentFields.learner_stage_2_total,
        null,
        studentFields.learner_performance_level,
        true
      )}

      {/* Peer Feedback */}
      {renderSection(
        'Peer Feedback',
        '#FFD966',
        'black',
        null,
        null,
        studentFields.peer_stage_3_total,
        studentFields.peer_performance_level,
        false
      )}

      {/* Page Number */}
      <div style={{
        position: 'absolute',
        bottom: '15mm',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '11px',
        color: '#666',
        fontWeight: 'bold'
      }}>
        27
      </div>

      {/* Bottom corners */}
      <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 0 0 60px',
        borderColor: 'transparent transparent transparent #F4824C'
      }} />
      <div style={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: '60px 60px 0 0',
        borderColor: 'transparent #F4824C transparent transparent',
        opacity: 0.3
      }} />
    </div>
  );
};

export default PartCPage9;
